<sk-modal-content [title]="label | translate"
                  cancelBtnText="label.Close"
                  confirmByKeypress
                  (confirmed)="confirmSelection()"
                  (cancelled)="closeWithoutResult()"
                  (closed)="closeWithoutResult()">

  <ng-container id="sk-modal-body">
    @if (showFoldersTree()) {
      <iris-dms-mat-folders-tree></iris-dms-mat-folders-tree>
    } @else {
      <span>{{ projectInfoMessage() | translate }}</span>
    }
  </ng-container>

  <ng-container id="sk-modal-footer-buttons">
    <sk-button
      [color]="'primary'"
      [label]="label | translate"
      data-test="modal-footer-confirm-button"
      [disabled]="submitDisabled()"
      (click)="confirmSelection()"
    >
      <ng-template buttonPrefix>
        <i class="fas fa-check"></i>
      </ng-template>
    </sk-button>
    <sk-button
      data-test="modal-footer-confirm-button"
      [color]="'primary'"
      [label]="'label.dms.MoveAndOpen' | translate"
      [disabled]="submitDisabled()"
      (click)="confirmSelection(true)"
    >
      <ng-template buttonPrefix>
        <i class="fas fa-check"></i>
      </ng-template>
    </sk-button>
  </ng-container>
</sk-modal-content>
